<app-side-menu>
  <div class="stock-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="warehouseFilter" class="form-label">Filtrar por Almoxarifado:</label>
          <select 
            id="warehouseFilter" 
            class="form-select" 
            [(ngModel)]="selectedWarehouseId"
            (change)="onWarehouseFilterChange(selectedWarehouseId)">
            <option value="">Todos os almoxarifados</option>
            <option *ngFor="let w of warehouses" [value]="w.id">
              {{ w.name }} ({{ w.code }})
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="typeFilter" class="form-label">Filtrar por Tipo:</label>
          <select 
            id="typeFilter" 
            class="form-select" 
            [(ngModel)]="selectedType"
            (change)="onTypeFilterChange(selectedType)">
            <option value="">Todos os tipos</option>
            <option *ngFor="let t of typeOptions" [value]="t">{{ t }}</option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select 
            id="statusFilter" 
            class="form-select" 
            [(ngModel)]="selectedStatus"
            (change)="onStatusFilterChange(selectedStatus)">
            <option value="">Todos os status</option>
            <option *ngFor="let s of statusOptions" [value]="s.name">{{ s.name }}</option>
          </select>
        </div>

        <div class="filter-actions">
          <button 
            type="button" 
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <app-table
      [title]="tableTitle"
      [columns]="columns"
      [data]="stocks"
      [loading]="loading"
      [showSearch]="showSearch"
      [searchPlaceholder]="searchPlaceholder"
      [searchTerm]="searchTerm"
      [clickable]="clickable"
      [actions]="actions"
      [totalItemsFromBackend]="totalItems"
      [hasNextPageFromBackend]="hasNextPage"
      [hasPreviousPageFromBackend]="hasPreviousPage"
      [currentPageFromBackend]="currentPage"
      [itemsPerPage]="pageSize"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      [enableSorting]="true"
      (sortChange)="onSortChange($event)"
      (searchChange)="onSearchChange($event)"
      (actionClick)="onActionClick($event)">
      <app-button
        table-header-action
        text="Novo Estoque"
        [color]="'var(--primary-light)'"
        [height]="'42px'"
        className="new-stock-btn"
        (buttonClick)="newStock()">
      </app-button>
    </app-table>
  </div>

  <!-- Modal de Gerenciamento de Almoxarifado -->
  <app-stock-warehouse-modal
    [stock]="selectedStock"
    [isVisible]="showWarehouseModal"
    (close)="closeWarehouseModal()"
    (success)="onWarehouseOperationSuccess()">
  </app-stock-warehouse-modal>
</app-side-menu>
